export function maprange(number, in_min, in_max, out_min, out_max){
    const mapped = ((number - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
    return mapped;
  }